import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "btn-wrapper" }

import NotificationsTable from '@/components/Notification/NotificationsTable.vue';
import useAppMixin from '@/mixins/appMixin';
import useTablePaginationMixin from '@/mixins/tablePaginationMixin';
import { DEFAULT_PAGINATION_PAGE, PAGINATION_TABLES_NAMES, ROUTE_KEYWORDS } from '@/utils/constants';
import { onBeforeRouteLeave } from 'vue-router';
  

export default /*#__PURE__*/_defineComponent({
  __name: 'Notifications',
  setup(__props) {

const { setPageTitle } = useAppMixin();
setPageTitle('PageTitle.Notifications.Default');
const { handleUpdatePage } = useTablePaginationMixin();

onBeforeRouteLeave((to) => { 
  if (!to.path.includes(ROUTE_KEYWORDS.NOTIFICATION)) {
    handleUpdatePage(PAGINATION_TABLES_NAMES.NOTIFICATONS, DEFAULT_PAGINATION_PAGE);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_btn, {
          "prepend-icon": "mdi-plus",
          variant: "flat",
          to: "/notifications/create"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Button.CreateNotification')), 1)
          ]),
          _: 1
        })
      ]),
      _createVNode(NotificationsTable)
    ]),
    _: 1
  }))
}
}

})